import { call, put } from "redux-saga/effects";
import { postCreateProduct } from "../api";
import * as types from "../consts";

export function* postCreateProductRequestSaga({
  payload,
}: ReturnType<typeof Object>) {
  try {
    const product: object = yield call(postCreateProduct, payload);
    yield put({ type: types.POST_CREATE_PRODUCT_SUCCESS, response: product });
  } catch (error) {
    yield put({ type: types.POST_CREATE_PRODUCT_ERROR, error });
  }
}
